import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { type AuthCallbackResult, handleAuthCallback, logout } from '../auth0';
import { LOGOUT_REASON } from '../authConstants';
import { type LogoutHandler } from '../types';

interface AuthCallbackProps {
  onLogin: (authResult: AuthCallbackResult) => Promise<void>;
  logoutHandlers: { current: LogoutHandler }[];
}

/**
 * Component to handle an auth callback from Auth0.
 */
const AuthCallback: React.FC<AuthCallbackProps> = ({ onLogin, logoutHandlers }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    Promise.resolve()
      .then(async () => {
        const response = await handleAuthCallback(location.hash);
        await onLogin(response);
      })
      .catch((err) => {
        if (err.errorDescription?.includes('SSO user provisioning error')) {
          navigate(`/sso-error?message=${encodeURIComponent(err.errorDescription)}`);
        } else if (err.message?.includes('SSO user provisioning error')) {
          navigate(`/sso-error?message=${encodeURIComponent(err.message)}`);
        } else {
          logout(undefined, logoutHandlers, LOGOUT_REASON.AUTHENTICATION_ERROR);
        }
      });
  }, [navigate, logoutHandlers, location.hash, onLogin]);

  return null;
};

export default AuthCallback;
